howspace.widgets.spacer = (() => {
    'use strict';
    const minWidth = 10;
    const maxWidth = 600;
    const saveTimeoutDelayInMs = 1000;
    const moveStep = 10;
    let isDragging = false;
    let dragBtn = null;
    let spacer = null;
    let startHeight = 0;
    let startY = 0;
    let payload = null;
    let widget = null;
    let saveTimeoutId = null;

    const getMinMaxWidth = width => {
        return Math.min(maxWidth, Math.max(minWidth, width));
    };

    const initChangeHeightDrag = widget => {
        widget.on('pointerdown', '.adjust-height-btn', onPointerDown);
        widget.on('pointermove', '.adjust-height-btn', onPointerMove);
        widget.on('pointerup', '.adjust-height-btn', onPointerUp);
        widget.on('keydown', '.adjust-height-btn', onKeyDown);
    };

    const initDragFromEvent = e => {
        dragBtn = e.target;
        isDragging = true;
        widget = $(dragBtn).closest('.widget');
        spacer = $(dragBtn).closest('.spacer-content').find('.spacer-type');
        startHeight = parseInt(spacer.data('spacer-height'));
    };

    const onPointerDown = e => {
        initDragFromEvent(e);
        e.target.setPointerCapture(e.pointerId);
        startY = e.clientY;
    };

    const onPointerMove = e => {
        if (!isDragging) {
            return;
        }

        const deltaY = e.clientY - startY;

        let newHeight = startHeight + deltaY;
        changeSpacerHeight(newHeight);
    };

    const onPointerUp = e => {
        isDragging = false;
        if (e.target.releasePointerCapture) {
            e.target.releasePointerCapture(e.pointerId);
        }
        saveHeight();
    };

    const onKeyDown = e => {
        const moveDown = e.key === 'ArrowDown';
        const moveUp = e.key === 'ArrowUp';

        if (!moveDown && !moveUp) {
            return;
        }

        initDragFromEvent(e);

        let newHeight = startHeight + (moveDown ? moveStep : -moveStep);
        changeSpacerHeight(newHeight);

        saveTimeout();

        e.preventDefault();
    };

    const changeSpacerHeight = (height) => {
        const newHeight = Math.ceil(getMinMaxWidth(height));
        spacer.css('--spacer-size', `${newHeight}px`);
        spacer.dataAndAttr('spacer-height', newHeight);
        const tooltipText = howspace.translate('spacer_adjust_height_tooltip', { height: newHeight });
        howspace.components.toolTip.update(dragBtn, tooltipText);

        payload = {
            height: newHeight
        };
    };

    const saveTimeout = () => {
        if (saveTimeoutId !== null) {
            clearTimeout(saveTimeoutId);
        }
        saveTimeoutId = setTimeout(saveHeight, saveTimeoutDelayInMs);
    };

    const saveHeight = () => {
        if (!payload) {
            return;
        }

        real.ajax.json(howspace.widgets.getApiUrl(widget), {
            type: 'POST',
            data: JSON.stringify(payload)
        });

        // Reset some variables.
        isDragging = false;
        payload = null;
        spacer = null;
        dragBtn = null;
        startHeight = 0;
        startY = 0;
        widget = null;
    };

    return {
        initView: widget => {
            initChangeHeightDrag(widget);
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            widget.on(howspace.components.colorPicker.COLOR_PICKER_PICK, e => {
                const color = e.detail.color.hsl;
                widget.find('.spacer-visual[data-spacer-type="divider"]').css('--spacer-color', color);
            });

            widget.on('change', '.divider-type', function () {
                const type = $(this).val();

                $.ajax({
                    url: howspace.widgets.getUrl(widget) + '/divider-svg?type=' + encodeURIComponent(type),
                    dataType: 'xml',
                    success: function (svgData) {
                        const visual = widget.find('.spacer-visual[data-spacer-type="divider"]');
                        visual.html(svgData.documentElement);
                        visual.css('--spacer-visual-bg', 'var(--howspace-color-white)');
                        if (type === 'shadow_down_white' || type === 'shadow_up_white') {
                            visual.css('--spacer-visual-bg', 'var(--howspace-color-black-55)');
                        }
                    },
                    error: function () {
                        console.error('Failed to load the SVG.');
                    }
                });
            });

            widget.on('change', '.spacer-height', function (e) {
                e.stopPropagation();
                const height = $(this).val();
                if (!height || height < minWidth || height > maxWidth) {
                    howspace.form.markInvalidField($(this));
                    widget.find('.save-widget-btn').prop('disabled', true);
                    return;
                }
                howspace.form.clearInvalidField($(this));
                widget.find('.save-widget-btn').attr('disabled', false);
            });

            widget.on('change', '.spacer-type', function (e) {
                e.stopPropagation();
                const type = $(this).val();
                if (type === 'divider') {
                    widget.find('.divider-type').trigger('change');
                }
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        }
    };
})();
